import { gql } from "lib/apolloClient";
import {
  publishedDataFragments,
  dataSetNodeCountWrapperFragment,
  dataSetNodeCountWrapperFragmentPyp,
} from "./Fragments";

export const getRootNodesFromNodeSetQuery = gql`
  query getRootNodesFromNodeSet(
    $id: ID!
    $nodesFilters: PlannerElementNodeFilters
  ) {
    node(id: $id, type: PLANNER_ELEMENT_NODE_SET) {
      ... on PlannerElementNodeSet {
        id
        plannerElementNodeSetWrapperV2 {
          ... on PlannerElementNodeSetWrapper {
            publishedData(filters: $nodesFilters) {
              edges {
                node {
                  ...plannerElementRootNodeItem
                }
              }
            }
          }
          ... on PlannerBenchmarkSetWrapper {
            publishedData(filters: $nodesFilters) {
              edges {
                node {
                  ...plannerBenchmarkRootItem
                }
              }
            }
          }
          ... on PlannerATLSetWrapper {
            publishedData(filters: $nodesFilters) {
              edges {
                node {
                  ...plannerATLRootItem
                }
              }
            }
          }
        }
      }
    }
  }
  ${publishedDataFragments.plannerBenchmarkRootFragment}
  ${publishedDataFragments.plannerElementRootNodeFragment}
  ${publishedDataFragments.plannerATLRootFragment}
`;

export const getRootNodesFromSetQuery = gql`
  query getRootNodesFromSet(
    $id: ID!
    $nodesFilters: PlannerElementNodeFilters
    $nodeSetFilters: PlannerElementNodeSetsByPlannerElementFilters
  ) {
    node(id: $id, type: PLANNER_ELEMENT_SET) {
      id
      ... on PlannerElementSet {
        plannerElementNodeSets(filters: $nodeSetFilters) {
          id
          plannerElementNodeSetWrapperV2 {
            ... on PlannerElementNodeSetWrapper {
              publishedData(filters: $nodesFilters) {
                edges {
                  node {
                    ...plannerElementRootNodeItem
                  }
                }
              }
            }
            ... on PlannerBenchmarkSetWrapper {
              publishedData(filters: $nodesFilters) {
                edges {
                  node {
                    ...plannerBenchmarkRootItem
                  }
                }
              }
            }
            ... on PlannerATLSetWrapper {
              publishedData(filters: $nodesFilters) {
                edges {
                  node {
                    ...plannerATLRootItem
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${publishedDataFragments.plannerBenchmarkRootFragment}
  ${publishedDataFragments.plannerATLRootFragment}
  ${publishedDataFragments.plannerElementRootNodeFragment}
`;

export const getPublishedNodesFromNodeSetQuery = gql`
  query getPublishedNodesFromNodeSet(
    $id: ID!
    $nodesFilters: PlannerElementNodeFilters
    $lockingInfoFilters: LockingInfoFiltersInput
    $skipLockingInfo: Boolean = true
  ) {
    node(id: $id, type: PLANNER_ELEMENT_NODE_SET) {
      ... on PlannerElementNodeSet {
        id
        plannerElementNodeSetWrapperV2 {
          ... on PlannerElementNodeSetWrapper {
            publishedData(filters: $nodesFilters) {
              edges {
                node {
                  ...plannerElementNodeItem
                }
              }
            }
          }
          ... on PlannerBenchmarkSetWrapper {
            publishedData(filters: $nodesFilters) {
              edges {
                node {
                  ...plannerBenchmarkItem
                }
              }
            }
          }
          ... on PlannerATLSetWrapper {
            publishedData(filters: $nodesFilters) {
              edges {
                node {
                  ...plannerATLItem
                }
              }
            }
          }
        }
      }
    }
  }
  ${publishedDataFragments.plannerBenchmarkFragment}
  ${publishedDataFragments.plannerAtlFragment}
  ${publishedDataFragments.plannerElementNodeFragment}
`;

export const getPublishedNodesFromSetQuery = gql`
  query getPublishedNodesFromSet(
    $id: ID!
    $nodesFilters: PlannerElementNodeFilters
    $nodeSetFilters: PlannerElementNodeSetsByPlannerElementFilters
    $lockingInfoFilters: LockingInfoFiltersInput
    $skipLockingInfo: Boolean = true
  ) {
    node(id: $id, type: PLANNER_ELEMENT_SET) {
      id
      ... on PlannerElementSet {
        plannerElementNodeSets(filters: $nodeSetFilters) {
          id
          plannerElementNodeSetWrapperV2 {
            ... on PlannerElementNodeSetWrapper {
              publishedData(filters: $nodesFilters) {
                edges {
                  node {
                    ...plannerElementNodeItem
                  }
                }
              }
            }
            ... on PlannerBenchmarkSetWrapper {
              publishedData(filters: $nodesFilters) {
                edges {
                  node {
                    ...plannerBenchmarkItem
                  }
                }
              }
            }
            ... on PlannerATLSetWrapper {
              publishedData(filters: $nodesFilters) {
                edges {
                  node {
                    ...plannerATLItem
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${publishedDataFragments.plannerBenchmarkFragment}
  ${publishedDataFragments.plannerAtlFragment}
  ${publishedDataFragments.plannerElementNodeFragment}
`;

export const getCurriculumSubjectsSubjectGroupsGradesAndTagsQuery = gql`
  query getCurriculumSubjectsSubjectGroupsGradesAndTags(
    $orgId: ID!
    $curriculumProgramId: ID!
    $shouldSkipSubjects: Boolean = false
    $shouldSkipGrades: Boolean = false
    $shouldSkipGenericTags: Boolean = false
    $shouldSkipSubjectGroups: Boolean = false
    $genericTagsFilter: GenericTagsFilter
  ) {
    node(id: $orgId, type: ORGANIZATION) {
      ... on Organization {
        id
        subjects(
          filters: {
            curriculumProgramIds: [$curriculumProgramId]
            archivalState: ACTIVE
          }
        ) @skip(if: $shouldSkipSubjects) {
          id
          name
        }
        grades(filters: { curriculumProgramIds: [$curriculumProgramId] })
          @skip(if: $shouldSkipGrades) {
          id
          name
        }
        genericTagsV2(filters: $genericTagsFilter)
          @skip(if: $shouldSkipGenericTags) {
          id
          label
        }
        subjectGroups(
          filters: { curriculumProgramIds: [$curriculumProgramId] }
        ) @skip(if: $shouldSkipSubjectGroups) {
          id
          name
        }
      }
    }
  }
`;

export const getPublishedNodesTaggedInDataFromNodeSetQuery = gql`
  query getPublishedNodesTaggedInDataFromNodeSetQuery(
    $id: ID!
    $nodesFilters: PlannerElementNodeFilters
    $nodeCountFilters: DataSetNodeCountWrapperFilters
    $shouldSkipAssessment: Boolean! = false
    $shouldSkipPortfolio: Boolean! = false
    $shouldSkipUnitPlan: Boolean! = false
    $isParentTaggingEnabled: Boolean! = false
  ) {
    node(id: $id, type: PLANNER_ELEMENT_NODE_SET) {
      ... on PlannerElementNodeSet {
        id
        plannerElementNodeSetWrapperV2 {
          ... on PlannerElementNodeSetWrapper {
            publishedData(filters: $nodesFilters) {
              edges {
                node {
                  ...dataSetNodeCountWrapperFragment
                }
              }
            }
          }
          ... on PlannerBenchmarkSetWrapper {
            publishedData(filters: $nodesFilters) {
              edges {
                node {
                  ...dataSetNodeCountWrapperFragmentPyp
                }
              }
            }
          }
        }
      }
    }
  }
  ${dataSetNodeCountWrapperFragment}
  ${dataSetNodeCountWrapperFragmentPyp}
`;

export const getSubjectVariantsQuery = gql`
  query getSubjectVariants($subjectId: ID!) {
    node(id: $subjectId, type: SUBJECT) {
      id
      ... on Subject {
        id
        variants {
          level {
            id
            label
            type
          }
        }
      }
    }
  }
`;
